import { render, staticRenderFns } from "./RoundItem.vue?vue&type=template&id=192c23a1&scoped=true&"
import script from "./RoundItem.vue?vue&type=script&lang=js&"
export * from "./RoundItem.vue?vue&type=script&lang=js&"
import style0 from "./RoundItem.vue?vue&type=style&index=0&id=192c23a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c23a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192c23a1')) {
      api.createRecord('192c23a1', component.options)
    } else {
      api.reload('192c23a1', component.options)
    }
    module.hot.accept("./RoundItem.vue?vue&type=template&id=192c23a1&scoped=true&", function () {
      api.rerender('192c23a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/RoundItem.vue"
export default component.exports